import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { BookingService } from './../../services/booking.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LocationService } from '../../services/location.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.sass']
})
export class ListComponent implements OnDestroy, OnInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  elements: any;
  dtOptions: any = {};
  otherList: any;
  dtTrigger = new Subject();
  elemForm = new FormGroup({
    bookingNo: new FormControl(),
    firstName: new FormControl(),
    dateOfBirth: new FormControl(),
    mobile: new FormControl(),
    departureFlightNo: new FormControl(),
    departureLocation: new FormControl(),
    departureDate: new FormControl(),
    bookingFromDate: new FormControl(),
    passport: new FormControl(),
    secondName: new FormControl(),
    email: new FormControl(),
    bookingType: new FormControl(),
    arrivalFlightNo: new FormControl(),
    arrivalLocation: new FormControl(),
    arrivalDate: new FormControl(),
    nationality: new FormControl()
  });

  constructor(private readonly _service: BookingService, private readonly _service1: LocationService) { }

  async ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    };
    this.otherList = await this._service1.getList();
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  async send () {
    const form = this.elemForm.value;
    if (form.departureLocation == 'false') {
      delete form.departureLocation
    }
    if (form.arrivalLocation == 'false') {
      delete form.arrivalLocation
    }
    if (form.bookingFromDate) {
      form.bookingFromDate = new Date(form.bookingFromDate).toISOString();
    }
    if (form.departureDate) {
      form.departureDate = new Date(form.departureDate).toISOString();
    }
    if (form.arrivalDate) {
      form.arrivalDate = new Date(form.arrivalDate).toISOString();
    }
    this.elements = await this._service.search(form);
    console.log(this.elements);
    this.rerender();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  resetAll() {
    this.elements = [];
    this.elemForm.reset();
    this.rerender();
  }

}
